import { request } from './index';
import { Loadable } from 'recoil';

export interface GetAddressParam {
  token: string;
  zipcode: string;
}
export interface Address {
  result: 'OK' | 'NG';
  message: string | null;
  prefecture: string;
  city: string;
  address: string;
}

export const getAddress = (param: GetAddressParam): Loadable<Address> => {
  return request('GetAddress', param);
}
